<template>
    <bill-shell title="ZESA Electricity Tokens">
        <section id="more" class="py-5 bg-white">
            <div class="container text-center">
                <img style="height: 56px" src="/img/zetdc-logo.webp" alt="">
                <h2 class="text-9 font-weight-bold mb-4 mt-2">Prepaid Meters: A Guide to Zesa Tokens on Magetsi.co.zw
                </h2>
                <p class="text-3">
                    Welcome to your one-stop shop for managing your electricity needs in Zimbabwe! Here at Magetsi, we understand the importance of having a reliable and convenient way to purchase and manage your Zesa tokens. This comprehensive guide will equip you with all the information you need to navigate the world of Zesa tokens, from understanding their purpose to purchasing them effortlessly on our secure platform.

                </p>
            </div>
        </section>
        <section class=" pb-5 bg-white">
            <div class="container">
                <h3 class="text-7 font-weight-bold mb-5 text-center"> What are Zesa Tokens? </h3>

                <div class="row">
                    <div class="">
                        <div class="text-3 text-center">
                            <p>
                                Zesa, also known as the Zimbabwe Electricity Transmission and Distribution Company (ZETDC), is the primary provider of electricity in Zimbabwe. They offer a pre-paid metering system where consumers purchase tokens, which are essentially electronic vouchers, to top up one’s electricity meter. The Zesa Token contains a 20-digit number that converts to the amount of units you will get.

                            </p>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-5 p-lg-5 d-flex align-content-center">
                        <img class="rounded-lg shadow-lg w-100" src="/images/fast-tracking-vs-crashing-article.jpg"
                             alt="">
                    </div>
                    <div class="col-lg-7 p-lg-5">
                        <h5 class="text-5 font-weight-bold mb-2"> Zimbabwe’s Introduction To Prepaid Meters: Why Use Zesa Tokens?</h5>
                        <div class="text-3 text-justify">

                            <p>
                                There are several advantages to using Zesa tokens:

                            </p>
                            <ul class="text-3">
                                <li class="py-1">
                                    Budgeting: By pre-paying for your electricity, you gain greater control over your spending. You can top up your meter as needed, preventing unexpected high bills at the end of the month.

                                </li>
                                <li  class="py-1">
                                    Convenience: Gone are the days of long queues and inconvenient payment schedules. With Zesa tokens, you can purchase electricity anytime, anywhere, directly through Magetsi's user-friendly online platform.

                                </li>
                                <li  class="py-1">
                                    Improved Cash Flow: For businesses, Zesa tokens eliminate the need for hefty deposits or monthly bills. You only pay for the electricity you consume, improving cash flow management.

                                </li>
                                <li  class="py-1">
                                    Reduced Risk of Disconnection: Running out of credit on your pre-paid meter can lead to power disconnection. By purchasing Zesa tokens regularly, you ensure an uninterrupted electricity supply for your needs.

                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        <section class="section py-5 bg-light-4">
            <div class="container">
                <h2 class="text-center text-9 font-weight-bold mb-4"> How to Buy Your Zesa Online on Magetsi </h2>
                <div class="bg-white shadow-sm rounded mb-4 p-4">
                    <div class="text-sm-start">
                        <h5 class="text-3 text-body">Magetsi makes buying Zesa tokens a breeze. Here's a step-by-step guide:</h5>
                        <ul class="text-3">
                            <li class="py-1">
                                Visit Magetsi.co.zw: Head over to our website and navigate to the "Buy Zesa Token" section.
                            </li>
                            <li  class="py-1">
                                Enter Your Meter Number: Accurately input your unique Zesa meter number. This ensures the token is credited to the correct account.

                            </li>
                            <li  class="py-1">
                                Select the Desired Amount: Choose the amount of electricity you wish to purchase. The minimum amount changes depending on the current zesa tariffs. (put a link to the current zesa tarifs page on the word, current zesa tariffs)

                            </li>
                            <li  class="py-1">
                                Choose Your Payment Method: Magetsi provides several secure payment options to cater to your preferences. You can choose from EcoCash, VISA, or Mastercard.

                            </li>
                            <li  class="py-1">
                                Complete the Transaction: Follow the on-screen instructions to finalize your payment. Once successful, you'll receive a confirmation message and your Zesa token.

                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <section class="section mb-0 bg-white text-left">
            <div class="container">
                <h3 class="text-5 font-weight-bold text-left">Using EcoCash to Buy Zesa Tokens on Magetsi</h3>
                <p class="text-3 ">
                    EcoCash is a popular mobile money transfer service widely used in Zimbabwe. Here's how to utilize EcoCash for your Zesa token purchase on Magetsi:
                    <br>

                </p>
                <ol class="text-3">
                    <li class="py-1">
                        Follow Steps 1-3 from the previous section.
                    </li>
                    <li  class="py-1">
                        Select EcoCash as your payment method. You'll be presented with a unique reference number.
                    </li>
                    <li  class="py-1">
                        You will receive a prompt message on your mobile.
                    </li>
                    <li  class="py-1">
                        Enter your EcoCash PIN. Once confirmed, the payment will be processed.
                    </li>
                </ol>
            </div>
            <div class="container">
                <h3 class="text-5 font-weight-bold text-left">Viewing Your Zesa Token</h3>
                <p class="text-3 ">
                    There are two ways to view your Zesa token after a successful purchase on Magetsi:
                    <br>
                </p>
                <ol class="text-3">
                    <li class="py-1">
                        Text Message: Your token will be sent to your phone soon after your transaction is completed
                    </li>
                    <li  class="py-1">
                        WhatsApp Message: When you purchase your zesa token online using our WhatsApp platform you will receive your token via WhatsApp.
                    </li>
                </ol>
            </div>
            <div class="container">
                <h3 class="text-5 font-weight-bold text-left">Retrieving Lost Zesa Tokens</h3>
                <p class="text-3 ">
                    If you happen to misplace your Zesa token, fret not! You can retrieve it using the following methods:
                    <br>
                </p>
                <ol class="text-3">
                    <li class="py-1">
                        Magetsi Platform: Contact Magetsi customer support if you purchased the token on our platform.
                    </li>
                    <li  class="py-1">
                        Magetsi Website: We have a facility for our customers to check their previous
                    </li>
                </ol>
            </div>
            <div class="container">
                <h3 class="text-5 font-weight-bold text-left">Zesa Token Prices</h3>
                <p class="text-3 ">
                    Zesa token prices change on a regular basis, the best way to get accurate results is through our Magetsi
                    calculator, a system that allows you to calculate the number of units you can get after your purchase.
                    Alternatively, you can use the zesa token prices table below. Remember to take into consideration your
                    consumption band when using the table.
                    <br>
                </p>
                <ol class="text-3">
                    <li class="py-1">
                        Magetsi Platform: Contact Magetsi customer support if you purchased the token on our platform.
                    </li>
                    <li  class="py-1">
                        Magetsi Website: We have a facility for our customers to check their previous
                    </li>
                </ol>
                <div class="col-12 col-lg-8 pt-3">
                    <tariffs-table></tariffs-table>
                </div>
            </div>

        </section>
    </bill-shell>
</template>

<script>
import Carousel from "../../custom/carousel.vue";
import BillShell from "../bill-shell.vue";
import TariffsTable from "../../custom/tariffs-table.vue";

export default {
    name: "dashboard",
    components: {BillShell,TariffsTable, Carousel, WelcomeInfo: () => import("../../shared/welcome-info.vue")},
    data: () => ({
        car: 1,
        content: [
            {
                title: 'Buy Prepaid\nZESA Tokens\nFor You or Loved Ones',
                subtitle: 'In just a few clicks, you can buy your prepaid ZESA token and send them to your phone. Also, get a receipt when you purchase using Magetsi. Accepted payment methods on our platform include EcoCash, MasterCard, VISA, and other international cards.',
            },
            {
                title: 'Get Up To\n15% BONUS!!!',
                subtitle: 'When you pay using MasterCard, Visa, or other international cards.'
            }
        ]
    }),

    mounted() {
        const carousel = () => setTimeout(() => {
            if (this.car + 1 > 5) this.car = 1
            else this.car++

            carousel()
        }, 25000)

        carousel()
    },
    metaInfo() {
        return {
            title: "Buy ZESA Tokens",
        }
    }
}
</script>
